import { PropTypes, css, styled } from '../lib/imports';

const baseStyles = ({ theme }) => css`
  width: 100%;
  max-width: ${theme.elementSize.content};
`;

const Wrapper = styled('div')(baseStyles);

Wrapper.propTypes = {
  children: PropTypes.node,
};

export default Wrapper;
